module.exports = "/_next/static/images/gr-417337002087399ebc911be9c5818d6f.svg";